import { render, staticRenderFns } from "./BdoLogic.vue?vue&type=template&id=46b99ea2&"
import script from "./BdoLogic.vue?vue&type=script&lang=js&"
export * from "./BdoLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports